export const FreeTeamMemberScreen = ({ teamName }: { teamName: string }) => {
  return (
    <div className="flex flex-col gap-4 items-center h-full justify-center">
      <div className="i-ph:users-three text-bolt-ds-text-secondary w-6 h-6" />
      <div className="text-bolt-ds-text-primary text-lg font-semibold text-center max-w-80">
        Team {teamName} is not ready yet.
      </div>
      <div className="text-bolt-ds-text-secondary text-base text-center max-w-80">
        This team doesn’t have an active subscription. Please contact an admin to resume the setup.
      </div>
    </div>
  );
};
